import get from 'lodash.get';
import * as Actions from './rate-viewer.actions';

const CONNECT_BATCH_PROGRESS = {
  eventName: 'rate-browser',
  actionToDispatch: (pusherMessage) => {
    const data = get(pusherMessage, 'data');
    const jobGuid = get(pusherMessage, 'messageGuid');
    const { errorMessage } = data;
    if (errorMessage) {
      const errorPayload = {
        ...data.body,
        errorMessage,
      };
      return Actions.onRatesRecievedErrorPre(jobGuid, errorPayload);
    }
    return Actions.onRatesRecievedSuccessPre(jobGuid, data);
  },
};

export const RateViewerPusherActions = [CONNECT_BATCH_PROGRESS];
